export const routes = [
  {
    path: '/',
    name: 'home'
  },   
  {
    path: '/' ,
    props: true,
    component: () => import('@/App'),
    children: [
      {
        path: '',
        name: 'list',
        props: true,
        components: {
          default: () => import('@/pages/Home'),
        }
      }
    ]
  }
]

export default routes